import { useNavigate, useLocation } from "react-router-dom";
import { Eye, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const PreviewBanner = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const exitPreview = () => {
    const params = new URLSearchParams(location.search);
    params.delete("preview");
    const newSearch = params.toString();
    navigate(`${location.pathname}${newSearch ? `?${newSearch}` : ""}`, { replace: true });
  };

  return (
    <div className="bg-amber-500 text-amber-950 px-4 py-2 flex items-center justify-center gap-3 text-sm font-medium">
      <Eye className="h-4 w-4" />
      <span>Draft Preview Mode — This page may not be visible to the public</span>
      <Button
        size="sm"
        variant="ghost"
        onClick={exitPreview}
        className="h-6 px-2 text-amber-950 hover:bg-amber-600 hover:text-amber-950"
      >
        <X className="h-3 w-3 mr-1" />
        Exit Preview
      </Button>
    </div>
  );
};

export default PreviewBanner;
